import { api } from "@/api";
import {
  UpsertMatchSuspensionsParams,
  MatchSuspensionsEditorResponse,
} from "@/types/ApiResponses/SportEvent";

export const upsertMatchesSuspensions = async (
  data: UpsertMatchSuspensionsParams
): Promise<MatchSuspensionsEditorResponse> => {
  const res = await api.client.post(`/sport-events-new/suspensions`, data);
  return res.data;
};
